import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
	page: {
		flexDirection: "column",
		backgroundColor: "#FFFFFF",
		paddingVertical: "25px",
	},
	body: {
		paddingHorizontal: "25px",
	},
	header: {
		marginTop: "-25px",
		position: "relative",
		backgroundColor: "#0E3456",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "25px",
		color: "white",
		overflow: "hidden",
		marginBottom: "10px",
	},
	background: {
		position: "absolute",
		left: -5,
		bottom: -15,
		zIndex: -1,
	},
	subheading: {
		fontFamily: "Times-Bold",
		fontWeight: "900",
		fontSize: "12px",
		color: "#0E3456",
	},
	valueBox: {
		backgroundColor: "#0E34561B",
		padding: "10px",
		marginTop: "5px",
		minHeight: "30px",
		display: "flex",
		justifyContent: "center",
	},
	valueText: {
		fontWeight: 100,
		fontSize: "10px",
		color: "#0E3456",
	},
	logo: {
		width: 100,
	},
	section: {
		marginBottom: "5px",
		marginTop: "2px",
	},
	group: {
		display: "flex",
		flexDirection: "row",
		columnGap: "10px",
	},
	imgGroup: {
		flexWrap: "wrap",
	},
	groupItem: {
		width: "33.33%",
	},
	groupItemImg: {
		width: "31.33%",
		marginBottom: "10px",
	},
	h10: {
		height: 10,
	},
	Img: {
		width: "100%",
		height: "auto",
		maxHeight: 180,
		minHeight: 180,
		borderRadius: "2px",
	},
	listItem: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		marginTop: "5px",
	},
	listMarker: {
		backgroundColor: "#0E3456",
		width: "5px",
		height: "5px",
		borderRadius: "5px",
		marginRight: "5px",
	},
});
export default styles;
